<div class="teacher-app-popover">
  <div>
    <p class="hello">Hello, {{teacher.user.name}}!</p>
    <button (click)='commands.enterAccessCode(this)'>Access Code</button>
    <button (click)='commands.gotoFacebook(this)'>Facebook Group</button>
    <button (click)='commands.feedback(this)'>Contact Us</button>
    <div class="divider"></div>
    <button (click)='commands.reloadApp(this)'>Reload App</button>
    <div class="divider"></div>
    <button (click)='commands.logout(this)'>Log Out</button>
  </div>
</div>